import { Vec3 } from 'vec3';
export declare const server: (serv: Server) => void;
export declare const entity: (entity: Entity, serv: Server) => void;
declare global {
    interface Server {
        /** Returns array of players within loc. loc is a required paramater. The object contains:
         *
         * * world: World position is in
         * * position: Center position
         * * radius: Distance from position
         */
        'getNearby': (params: {
            world: Player['world'];
            position: Vec3;
            radius?: number;
        }) => Player[];
    }
    interface Entity {
        /** Gets all entities nearby (within entity.viewDistance) */
        "getNearby": () => Entity[];
        /** Gets every player other than self (all players if entity is not a player) */
        "getOtherPlayers": () => Player[];
        /**
         * Get every other entity other than self
         * Should not be used repeatedly as it is a slow operation
    
         */
        "getOthers": () => Server['entities'];
        /** Gets all nearby players regardless of what client thinks */
        "getNearbyPlayers": (radius?: number) => Player[];
        /** Gets all nearby players that client can see */
        "nearbyPlayers": (radius?: number) => Player[];
    }
}
